import {Navigate, Outlet} from "react-router-dom";
import {useAuth, UserStatus} from "./AuthProvider";
import Navbar from "../components/views/protected/Navbar";
import Footer from "../components/views/public/Footer";
import {Flex} from "@chakra-ui/react";

const RoutesForUsersDuringMigration = () => {
    const { userStatus } = useAuth();

    return userStatus === UserStatus.ToMigrate ?
        <>
            <Navbar />
            <Flex
                as="main"
                mb="50px" // Zwiększ margines od dołu, aby kontener nie był zasłonięty przez footer
                justifyContent="center"
                alignItems="center"
                width="100%"
            >
                <Outlet />
            </Flex>
            <Footer />
        </>
        :
        <Navigate to="/login" />;
};

export default RoutesForUsersDuringMigration;